import { render } from "./time.view.vue?vue&type=template&id=4b407a96&scoped=true&ts=true"
import script from "./time.view.vue?vue&type=script&lang=ts"
export * from "./time.view.vue?vue&type=script&lang=ts"

import "./time.view.vue?vue&type=style&index=0&id=4b407a96&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b407a96"]])

export default __exports__